import { render, staticRenderFns } from "./ticketList.vue?vue&type=template&id=ad24b4ae&scoped=true&"
import script from "./ticketList.vue?vue&type=script&lang=js&"
export * from "./ticketList.vue?vue&type=script&lang=js&"
import style0 from "./ticketList.vue?vue&type=style&index=0&id=ad24b4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad24b4ae",
  null
  
)

export default component.exports